import {
  faBowlFood,
  faChildReaching,
  faDumbbell,
  faFire,
  faGlassWater,
  faHeartPulse,
  faMoon,
  faPercent,
  faRulerCombined,
  faScaleBalanced,
  faUserCheck,
  faWeightScale,
} from "@fortawesome/free-solid-svg-icons";
import images from "../assets/images";
import { useTranslate } from "../context/TranslationContext";

export const useStaticData = () => {
  const { t } = useTranslate("staticData");

  // 🔹 BUSINESS KEY FEATURES
  const BUSSINESS_KEY_FEATURES = [
    {
      title: t("BUSINESS_FEATURES.expert"),
      text: t("BUSINESS_FEATURES.expertText"),
      icon: "briefcase",
    },
    {
      title: t("BUSINESS_FEATURES.community"),
      text: t("BUSINESS_FEATURES.communityText"),
      icon: "group",
    },
    {
      title: t("BUSINESS_FEATURES.learning"),
      text: t("BUSINESS_FEATURES.learningText"),
      icon: "growth",
    },
  ];

  // 🔹 ACHIEVEMENTS
  const ACHIEVEMENTS = [
    {
      title: t("ACHIEVEMENTS.courseCreation.title"),
      content: t("ACHIEVEMENTS.courseCreation.content"),
      image: images.success_stories.yoga,
    },
    {
      title: t("ACHIEVEMENTS.expandedReach.title"),
      content: t("ACHIEVEMENTS.expandedReach.content"),
      image: images.success_stories.yoga,
    },
    {
      title: t("ACHIEVEMENTS.communityBuilding.title"),
      content: t("ACHIEVEMENTS.communityBuilding.content"),
      image: images.success_stories.yoga,
    },
    {
      title: t("ACHIEVEMENTS.financialGrowth.title"),
      content: t("ACHIEVEMENTS.financialGrowth.content"),
      image: images.success_stories.yoga,
    },
  ];

  // 🔹 JOURNEY SOLUTIONS
  const JOURNEY_SOLUTIONS = [
    {
      title: t("JOURNEY_SOLUTIONS.corporate.title"),
      content: t("JOURNEY_SOLUTIONS.corporate.content"),
      image: images.about_us.five,
    },
    {
      title: t("JOURNEY_SOLUTIONS.individual.title"),
      content: t("JOURNEY_SOLUTIONS.individual.content"),
      image: images.about_us.six,
    },
  ];

  // 🔹 SOCIALS
  const SOCIALS = [
    {
      title: "linkedin",
      icon: "fa-linkedin-in",
      link: "https://www.linkedin.com/company/traineego/",
    },
    {
      title: "instagram",
      icon: "fa-instagram",
      link: "https://www.instagram.com/traineego",
    },
    {
      title: "facebook",
      icon: "fa-facebook",
      link: "https://www.facebook.com/traineego",
    },
    {
      title: "youtube",
      icon: "fa-youtube",
      link: "https://www.youtube.com/@traineego",
    },
  ];

  // 🔹 CALCULATORS
  const CALCULATORS = [
    {
      title: t("CALCULATORS.bmi"),
      description: t("CALCULATORS_DESC.bmi"),
      image: images.calculator.bmi,
      route: "/fitness-calculators/bmi",
      link: "BMI",
      icon: faWeightScale,
    },
    {
      title: t("CALCULATORS.bfp"),
      description: t("CALCULATORS_DESC.bfp"),
      image: images.calculator.bfp,
      route: "/fitness-calculators/body-fat-percentage",
      link: "Body Fat",
      icon: faPercent,
    },
    {
      title: t("CALCULATORS.macro"),
      description: t("CALCULATORS_DESC.macro"),
      image: images.calculator.macro,
      route: "/fitness-calculators/macro-nutrients",
      link: "Macro",
      icon: faBowlFood,
    },
    {
      title: t("CALCULATORS.bmr"),
      description: t("CALCULATORS_DESC.bmr"),
      image: images.calculator.bmr,
      route: "/fitness-calculators/bmr",
      link: "BMR",
      icon: faFire,
    },
    {
      title: t("CALCULATORS.heartRate"),
      description: t("CALCULATORS_DESC.heartRate"),
      image: images.calculator.heartRate,
      route: "/fitness-calculators/heart-rate",
      link: "Heart Rate",
      icon: faHeartPulse,
    },
    {
      title: t("CALCULATORS.idealBodyWeight"),
      description: t("CALCULATORS_DESC.idealBodyWeight"),
      image: images.calculator.idealBodyWeight,
      route: "/fitness-calculators/ideal-body-weight",
      link: "Ibw",
      icon: faUserCheck,
    },
    {
      title: t("CALCULATORS.waistToHip"),
      description: t("CALCULATORS_DESC.waistToHip"),
      image: images.calculator.waistToHip,
      route: "/fitness-calculators/waist-to-hip-ratio",
      link: "Wth",
      icon: faRulerCombined,
    },
    {
      title: t("CALCULATORS.hydration"),
      description: t("CALCULATORS_DESC.hydration"),
      image: images.calculator.hydration,
      route: "/fitness-calculators/hydration",
      link: "Hydration",
      icon: faGlassWater,
    },
    {
      title: t("CALCULATORS.oneRepMax"),
      description: t("CALCULATORS_DESC.oneRepMax"),
      image: images.calculator.oneRepMax,
      route: "/fitness-calculators/one-rep-max",
      link: "Orm",
      icon: faDumbbell,
    },
    {
      title: t("CALCULATORS.sleep"),
      description: t("CALCULATORS_DESC.sleep"),
      image: images.calculator.sleep,
      route: "/fitness-calculators/sleep",
      link: "Sleep",
      icon: faMoon,
    },
  ];

  // 🔹 BMI THRESHOLDS
  const baseBMIThresholds = [
    { label: t("BMI_THRESHOLDS.Underweight"), min: 0, max: 18.4 },
    { label: t("BMI_THRESHOLDS.Normal"), min: 18.5, max: 24.9 },
    { label: t("BMI_THRESHOLDS.Overweight"), min: 25, max: 29.9 },
    { label: t("BMI_THRESHOLDS.Obese"), min: 30, max: Infinity },
  ];

  // 🔹 FITNESS TESTS
  const FITNESSTEST = [
    {
      title: t("FITNESSTEST.cardio"),
      description: t("FITNESSTEST_DESC.cardio"),
      image: images.fitness_test.cardio,
      route: "/fitness-tests/cardio",
      link: "Cardio",
      icon: faHeartPulse,
    },
    {
      title: t("FITNESSTEST.strength"),
      description: t("FITNESSTEST_DESC.strength"),
      image: images.fitness_test.strength,
      route: "/fitness-tests/strength",
      link: "Strength",
      icon: faDumbbell,
    },
    {
      title: t("FITNESSTEST.flexibility"),
      description: t("FITNESSTEST_DESC.flexibility"),
      image: images.fitness_test.flexibility,
      route: "/fitness-tests/flexibility",
      link: "Flexibility",
      icon: faChildReaching,
    },
    {
      title: t("FITNESSTEST.balance"),
      description: t("FITNESSTEST_DESC.balance"),
      image: images.fitness_test.balance,
      route: "/fitness-tests/balance",
      link: "Balance",
      icon: faScaleBalanced,
    },
  ];

  // 🔹 THRESHOLDS (STRENGTH + SHOULDER)
  const baseThresholds = {
    male: [
      { label: t("THRESHOLDS.male.poor"), min: 0, max: 10 },
      { label: t("THRESHOLDS.male.belowaverage"), min: 11, max: 20 },
      { label: t("THRESHOLDS.male.average"), min: 21, max: 29 },
      { label: t("THRESHOLDS.male.good"), min: 30, max: 34 },
      {
        label: t("THRESHOLDS.male.excellent"),
        min: 35,
        max: Infinity,
      },
    ],
    female: [
      { label: t("THRESHOLDS.female.poor"), min: 0, max: 14 },
      {
        label: t("THRESHOLDS.female.belowaverage"),
        min: 15,
        max: 23,
      },
      { label: t("THRESHOLDS.female.average"), min: 24, max: 32 },
      { label: t("THRESHOLDS.female.good"), min: 33, max: 39 },
      {
        label: t("THRESHOLDS.female.excellent"),
        min: 40,
        max: Infinity,
      },
    ],
  };

  const baseThresholdsShoulder = {
    male: [
      { label: t("SHOULDER.male.excellent"), min: 0, max: 4 },
      { label: t("SHOULDER.male.good"), min: 5, max: 9 },
      { label: t("SHOULDER.male.average"), min: 10, max: 14 },
      { label: t("SHOULDER.male.belowaverage"), min: 15, max: 19 },
      { label: t("SHOULDER.male.poor"), min: 20, max: Infinity },
    ],
    female: [
      { label: t("SHOULDER.female.excellent"), min: 0, max: 3 },
      { label: t("SHOULDER.female.good"), min: 4, max: 7 },
      { label: t("SHOULDER.female.average"), min: 8, max: 11 },
      { label: t("SHOULDER.female.belowaverage"), min: 12, max: 15 },
      { label: t("SHOULDER.female.poor"), min: 16, max: Infinity },
    ],
  };

  const CALCULATOR_DATA = {
    GENDER: [
      { label: t("calculatorData.gender.male"), value: "male" },
      { label: t("calculatorData.gender.female"), value: "female" },
    ],

    WEIGHT_UNITS: [{ label: t("calculatorData.weightUnits.kg"), value: "kg" }],

    HEIGHT_UNITS: [{ label: t("calculatorData.heightUnits.cm"), value: "cm" }],

    ACTIVITY_LEVELS: [
      {
        label: t("calculatorData.activityLevels.sedentary"),
        value: "sedentary",
        multiplier: 1.2,
      },
      {
        label: t("calculatorData.activityLevels.light"),
        value: "light",
        multiplier: 1.375,
      },
      {
        label: t("calculatorData.activityLevels.moderate"),
        value: "moderate",
        multiplier: 1.55,
      },
      {
        label: t("calculatorData.activityLevels.very"),
        value: "very",
        multiplier: 1.7,
      },
      {
        label: t("calculatorData.activityLevels.super"),
        value: "super",
        multiplier: 1.9,
      },
    ],

    CLIMATE_OPTIONS: [
      { label: t("calculatorData.climateOptions.cold"), value: "cold" },
      {
        label: t("calculatorData.climateOptions.temperate"),
        value: "temperate",
      },
      { label: t("calculatorData.climateOptions.hot"), value: "hot" },
      { label: t("calculatorData.climateOptions.veryHot"), value: "very-hot" },
    ],

    ACTIVITY_RANGE: [
      {
        label: t("calculatorData.activityRange.light"),
        value: "light",
        range: [0.5, 0.6],
      },
      {
        label: t("calculatorData.activityRange.fatBurn"),
        value: "fat_burn",
        range: [0.6, 0.7],
      },
      {
        label: t("calculatorData.activityRange.cardio"),
        value: "cardio",
        range: [0.7, 0.8],
      },
      {
        label: t("calculatorData.activityRange.peak"),
        value: "peak",
        range: [0.8, 0.9],
      },
    ],

    FRAME_SIZE: [
      { label: t("calculatorData.frameSize.small"), value: "small" },
      { label: t("calculatorData.frameSize.medium"), value: "medium" },
      { label: t("calculatorData.frameSize.large"), value: "large" },
    ],

    LIFT: [
      { label: t("calculatorData.lift.squat"), value: "Squat" },
      { label: t("calculatorData.lift.bench"), value: "Bench Press" },
      { label: t("calculatorData.lift.deadlift"), value: "Deadlift" },
      { label: t("calculatorData.lift.overhead"), value: "Overhead Press" },
      { label: t("calculatorData.lift.row"), value: "Barbell Row" },
    ],

    LEVEL: [
      { label: t("calculatorData.level.low"), value: "low" },
      { label: t("calculatorData.level.medium"), value: "medium" },
      { label: t("calculatorData.level.high"), value: "high" },
    ],

    SLEEP_QUALITY: [
      { label: t("calculatorData.sleepQuality.good"), value: "good" },
      { label: t("calculatorData.sleepQuality.average"), value: "average" },
      { label: t("calculatorData.sleepQuality.poor"), value: "poor" },
    ],

    AGE_GROUP: [
      { label: t("calculatorData.ageGroup.20-29"), value: "20-29" },
      { label: t("calculatorData.ageGroup.30-39"), value: "30-39" },
      { label: t("calculatorData.ageGroup.40-49"), value: "40-49" },
      { label: t("calculatorData.ageGroup.50-59"), value: "50-59" },
      { label: t("calculatorData.ageGroup.60-69"), value: "60-69" },
    ],

    TEST: [
      { label: t("calculatorData.test.pushups"), value: "Push-ups" },
      { label: t("calculatorData.test.situps"), value: "Sit-ups" },
      { label: t("calculatorData.test.wallsit"), value: "Wall-Sit" },
    ],

    STRENGTH: [
      { value: "Push-ups", label: t("calculatorData.strength.pushups") },
      { value: "Sit-ups", label: t("calculatorData.strength.situps") },
      { value: "Wall-Sit", label: t("calculatorData.strength.wallsit") },
    ],

    FLEXIBILITY: [
      { value: "sit", label: t("calculatorData.flexibility.sit") },
      { value: "shoulder", label: t("calculatorData.flexibility.shoulder") },
    ],

    BALENCE: [
      {
        value: "singleleggedstand",
        label: t("calculatorData.balance.singleleggedstand"),
      },
      { value: "tandemwalk", label: t("calculatorData.balance.tandemwalk") },
    ],

    CHARTDROPDOWN: [
      { label: t("calculatorData.chartDropdown.week"), value: "week" },
      { label: t("calculatorData.chartDropdown.month"), value: "month" },
    ],
  };

  return {
    BUSSINESS_KEY_FEATURES,
    ACHIEVEMENTS,
    JOURNEY_SOLUTIONS,
    SOCIALS,
    CALCULATORS,
    CALCULATOR_DATA,
    baseBMIThresholds,
    FITNESSTEST,
    baseThresholds,
    baseThresholdsShoulder,
  };
};
